import { graphql } from '@/gql'

export const WebhookFragment = graphql(/* GraphQL */ `
  fragment WebhookFragment on Webhook {
    id
    title
    description
    url
    secret
    isActive
    clientId
    clientSecret
    clientUrl
    createdAt
    updatedAt
  }
`)

export const WebhookEventLogFragment = graphql(/* GraphQL */ `
  fragment WebhookEventLogFragment on WebhookEventLog {
    id
    key
    webhook {
      id
      title
      description
      owner
      url
      isActive
    }
    webhookEvent {
      id
      key
      event
      description
      payload
      createdAt
    }
    result
    statusCode
    request
    response
    createdAt
  }
`)
